import markdownContent from '!!raw-loader!static/terms.md';
import { Markdown } from 'Common';

export const AppTermsPage = () => {
  return (
    <Markdown className="app" scrollOffset={-10}>
      {markdownContent}
    </Markdown>
  );
};

export default AppTermsPage;
